import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function ParticleFilterCheckbox() {
  return (
    <Field
      name="hasDpf"
      type="checkbox"
      label={i18n.t('entity.vehicle.labels.particulateFilter')}
    />
  );
}
